<template>
    <v-layout align-center justify-center row wrap>
        <v-flex xs12 sm12 md12 lg9 xl8 class="pa-2">
            <div class="user-info" v-if="!silentLoading">
                <v-snackbar
                        v-model="userDataSaved"
                        color="success"
                        top
                >
                    Vaši podatki so se uspešno shranili.
                    <v-btn
                            text
                            @click="userDataSaved = false"
                    >
                        Zapri
                    </v-btn>
                </v-snackbar>
                <v-snackbar
                        v-model="userDataErrorSaving"
                        color="error"
                        top
                >
                    {{ userDataErrorSavingMSG }}
                    <v-btn
                            text
                            @click="userDataErrorSaving = false"
                    >
                        Zapri
                    </v-btn>
                </v-snackbar>
                <template v-if="displayData">
                    <p>
                        <label>Ime</label>
                        {{ name }}
                    </p>
                    <template v-if="!connected_account_is_temp">
                        <p>
                            <label>Priimek</label>
                            {{ lastname }}
                        </p>
                        <p>
                            <label>Ulica</label>
                            {{ street }}
                        </p>
                        <p>
                            <label>Hišna številka in dodatek</label>
                            {{ streetNo }}{{ streetNoExt}}
                        </p>
                        <p>
                            <label>Poštna številka</label>
                            {{ postCode }}
                        </p>
                        <p>
                            <label>Kraj</label>
                            {{ city }}
                        </p>
                        <p>
                            <label>Država</label>
                            {{ country|countryName }}
                        </p>
                        <p>
                            <label>Spol</label>
                            {{ gender|genderName }}
                        </p>
                        <p>
                            <label>Datum rojstva</label>
                            {{ birth|localDate }}
                        </p>
                        <p>
                            <label>Elektronski naslov</label>
                            {{ email }}
                        </p>
                        <p>
                            <label>Mobilna številka</label>
                            {{ mobileNo }}
                        </p>
                        <p>
                            <label>Stacionarni telefon</label>
                            {{ phoneNo }}
                        </p>
                        <p>
                            <label>Izobrazba</label>
                            {{ education|educationName }}
                        </p>
                        <p>
                            <label>Število družinskih članov</label>
                            {{ family|familyMembersName }}
                        </p>
                        <p>
                            <label>Status</label>
                            {{ status|personStatusName }}
                        </p>
                        <p v-if="childs && cChilds.length > 0">
                            <label>Datum rojstva in spol otrok</label>
                        </p>
                            <div v-if="childs && cChilds.length > 0">
                                <v-layout align-center justify-center row wrap>
                                    <template v-for="(child,i) in childs">
                                        <v-flex xs4 class="pa-2 ml-1">Otrok {{ i+1 }}</v-flex>
                                        <v-flex xs4 class="pa-2">{{ child.date_of_birth }}</v-flex>
                                        <v-flex xs3 class="pa-2">{{ child.gender|genderName  }}</v-flex>
                                    </template>
                                </v-layout>
                            </div>
                        <empty-space />
                        <v-btn depressed large block @click="editData">Spremeni podatke</v-btn>
                    </template>
                </template>


                <template v-if="!displayData">
                    <v-form v-model="valid" @submit.prevent="" ref="form">
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12 sm6 class="pa-1">
                                <input-field v-model="name" label="Ime" readonly="readonly" disabled="disabled" />
                            </v-flex>
                            <v-flex xs12 sm6 class="pa-1">
                                <input-field v-model="lastname" label="Priimek" :rules="checkNameLastnameRules"  />
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12 md6 sm6 class="pa-1">
                                <input-field v-model="street" label="Ulica" :rules="checkStreetNameRules" />
                            </v-flex>
                            <v-flex xs12 md3 sm3 class="pa-1">
                                <input-field v-model="streetNo" label="Hišna št." :rules="checkHouseNumberRules" />
                            </v-flex>
                          <v-flex xs12 md3 sm3 class="pa-1">
                            <input-field v-model="streetNoExt" label="Hišna št. dodatek" />
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12 md4 sm4 class="pa-1">
                                <input-field v-model="postCode" label="Poštna številka" v-on:blur="updatePlace" :rules="checkZIPNumberRules"/>
                            </v-flex>
                            <v-flex xs12 md8 sm8 class="pa-1">
                                <input-field v-model="city" label="Kraj" :rules="checkCityRules" />
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12 class="pa-1" row wrap>
                                <country label="Država" v-model="country" :rules="checkCountryRules" />
                            </v-flex>
                        </v-layout>
                        <phone-number label="Mobilna številka" v-model="mobileNo" :rules="checkPhoneNumberRules" autofocus />
                        <phone-number label="Stacionarna številka" v-model="phoneNo" :rules="checkPhoneNumberRules" />
                        <education label="Izobrazba" v-model="education" :rules="checkEducationRules" />
                        <family-members label="Družinski člani" v-model="family" :rules="checkFamilyMemberRules" />

                        <child-personal-data v-for="(child, i) in childs" :index="i" v-model="childs[i]" v-on:remove="removeChild" />
                        <v-flex xs12 class="pa-2">
                            <v-btn depressed large block @click="addChild" :disabled="!canAddChild">Dodaj dodatnega otroka</v-btn>
                            <div class="caption">Velja za otroke, mlajše od 18 let. Polnoleten otrok je vljudno vabljen, da se sam pridruži Tuš klubu.</div>
                        </v-flex>
                        <empty-space />
                        <person-status label="Status" v-model="status" :rules="checkPersonStatusRules" />
                    </v-form>
                    <v-btn depressed large block :loading="loading" @click="saveData()" color="primary_action">Shrani podatke</v-btn>
                    <v-btn depressed large block v-if="!loading" @click="cancelData()">Prekliči</v-btn>
                </template>


            </div>

            <div class="loader" v-if="silentLoading">
                <empty-space />
                <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
            </div>

        </v-flex>
    </v-flex>
    </v-layout>
</template>

<script>
    import InputField from "../InputField";
    import EmptySpace from "../EmptySpace";
    import DatePicker from "../DatePicker";
    import PhoneNumber from "../PhoneNumber";
    import Education from "../Education";
    import ChildPersonalData from "../ChildPersonalData";
    import FamilyMembers from "../FamilyMembers";
    import PersonStatus from "../PersonStatus";
    import Country from "../Country";
    import utils from "../../store/utils";
    import gutils from "../../utils";

    import GenderSelectionField from "../GenderSelectionField";
    import {userService, registrationService} from "../../services";
    import validations from "../validations";

    export default {
        name: "UserDataTab",
        components: {EmptySpace, InputField, DatePicker, GenderSelectionField, Country, PhoneNumber, Education, FamilyMembers, PersonStatus, ChildPersonalData},
        data: vm => ({
            displayData: true,
            loading: false,
            userDataSaved: false,
            userDataErrorSaving: false,
            userDataErrorSavingMSG: '',
            childs: [],
            checkNameLastnameRules: validations.checkNameLastname,
            checkStreetNameRules: validations.checkStreetName,
            checkHouseNumberRules: validations.checkHouseNumber,
            checkZIPNumberRules: validations.checkZIPNumber,
            checkCityRules: validations.checkCity,
            checkCountryRules: validations.checkCountry,
            checkDateOfBirthClubRules: validations.checkDateOfBirthClub,
            checkGender: validations.checkGender,
        }),
        computed: {
            silentLoading: utils.vuexBuildSetGet(this, 'profile', 'silentLoading'),
            connected_account_is_temp: utils.vuexBuildSetGet(this, 'profile', 'user.connected_account_is_temp'),
            name: utils.vuexBuildSetGet(this, 'profile', 'user.personal.name'),
            lastname: utils.vuexBuildSetGet(this, 'profile', 'user.personal.surname'),
            street: utils.vuexBuildSetGet(this, 'profile', 'user.personal.street'),
            streetNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.streetNo'),
            streetNoExt: utils.vuexBuildSetGet(this, 'profile', 'user.personal.streetNoExt'),
            postCode: utils.vuexBuildSetGet(this, 'profile', 'user.personal.postCode'),
            city: utils.vuexBuildSetGet(this, 'profile', 'user.personal.city'),
            country: utils.vuexBuildSetGet(this, 'profile', 'user.personal.country'),
            gender: utils.vuexBuildSetGet(this, 'profile', 'user.personal.sex'),
            birth: utils.vuexBuildSetGet(this, 'profile', 'user.personal.birth'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.personal.eMail'),
            mobileNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.mobileNo'),
            phoneNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.phoneNo'),
            education: utils.vuexBuildSetGet(this, 'profile', 'user.personal.education'),
            family: utils.vuexBuildSetGet(this, 'profile', 'user.personal.family'),
            status: utils.vuexBuildSetGet(this, 'profile', 'user.personal.status'),
            cChilds: function(){
                this.updateChilds();
                return this.childs;

            },
            canAddChild(){
                return this.childs.length < 4;
            }
        },
        filters: {
            countryName: function (value) {
                return gutils.countryName(value);
            },
            genderName: function (value) {
                return gutils.genderName(value);
            },
            educationName: function (value) {
                return gutils.educationName(value);
            },
            personStatusName: function (value) {
                return gutils.personStatusName(value);
            },
            familyMembersName: function (value) {
                return gutils.familyMembersName(value);
            },
        },
        methods: {
            removeChild(index){
                this.childs.splice(index, 1);
            },
            updateChilds(){
                let result = [];
                const personal = this.$store.state.profile.user.personal;
                if (personal) {
                    for (let i = 1; i < 8; i++) {
                        if (personal['child' + i + 'Birth']) {
                            result.push({
                                'date_of_birth': gutils.formatSlovenianDate(personal['child' + i + 'Birth']),
                                'gender': personal['child' + i + 'Sex']
                            });
                        }
                    }
                }
                this.childs = result;
            },
            updateChildsBack(){
                let maxIndex = 0;
                for(const [index,child] of this.childs.entries()){
                    this.$store.commit('setByPath', {
                        'p': 'profile.user.personal.child'+(index+1)+'Birth',
                        'v': gutils.formatAPIDate(gutils.toDateFromSlovenianDate(child['date_of_birth']))
                    });
                    this.$store.commit('setByPath', {
                        'p': 'profile.user.personal.child'+(index+1)+'Sex',
                        'v': child['gender']
                    });
                    maxIndex = index+1;
                }
                for(let i=maxIndex;i<4;i++){
                    this.$store.commit('setByPath', {
                        'p': 'profile.user.personal.child'+(i+1)+'Birth',
                        'v': ''
                    });
                    this.$store.commit('setByPath', {
                        'p': 'profile.user.personal.child'+(i+1)+'Sex',
                        'v': ''
                    });
                }
            },
            addChild(){
              this.childs.push({
                  'date_of_birth': '',
                  'gender': ''
              });
            },
            editData(){
                this.updateChilds();
                this.displayData = false;
            },
            updatePlace(){
                registrationService.postOffice(this.$store.state.profile.user.personal.postCode).then((data) => {
                    this.city = data['name'];
                    this.country = 'SI';
                });
            },
            saveData(){
                let isValid = this.$refs.form.validate();
                if (isValid){
                    this.loading = true;
                    this.userDataSaved = false;
                    this.updateChildsBack();
                    userService.updateUserData(this.$store.state.profile.user.personal).then((data) => {
                        this.displayData = true;
                        this.userDataSaved = true;
                    }, (error) => {
                        this.userDataErrorSaving = true;
                        this.userDataErrorSavingMSG = error.message;
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            },
            cancelData(){
                this.displayData = true;
                this.$store.dispatch('profile/silentAllAboutMe');
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../styles/variables.less";

    .loader{
        text-align: center;
    }

    .user-info p{
        padding: 5px;
        margin-bottom: 0px;
        font-weight: bold;
        border-top: 1px solid #c1c1c1;
    }

    .user-info p:last-child{
        border-bottom: 1px solid #c1c1c1;
    }
    .user-info label{
        font-weight: normal;
        width: 250px;
        display: inline-block;
    }
</style>